import { render } from "./NewPartnerRenderer.vue?vue&type=template&id=90ed9eda&scoped=true"
import script from "./NewPartnerRenderer.vue?vue&type=script&lang=js"
export * from "./NewPartnerRenderer.vue?vue&type=script&lang=js"

import "./NewPartnerRenderer.vue?vue&type=style&index=0&id=90ed9eda&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90ed9eda"]])

export default __exports__